<template>
  <div>
    <div v-if="loading"><h3>Loading...</h3></div>
    <div v-else>
      <div><div v-if="!showAllSites">Operating Review Year: {{ this.reviewYear }}
        Registration: {{ this.tmsRegistrationId }}

        <div style="margin-left: 250px; margin-top: -19px" v-if="showFooter && editPermission">
          <button
            @click="approveButtonClick"
            v-if="!showReview"
            class="e-control e-btn e-lib e-success"
          >
            Approve
          </button>
          <button v-else class="e-control e-btn e-lib e-info" @click="goToReview()">Review</button>
        </div>
      </div>
        <div style="display: flex; justify-content: end;margin-top: -5px" v-if="mySitesDS && mySitesDS.length > 0">
          <ejs-button
            type="Button"
            cssClass="e-success"
            style="margin-bottom: 10px"
            v-on:click.native="onExportToExcel"
          >
            Export to Excel
          </ejs-button>
        </div>
        <ejs-grid
          id="mySitesDSGridId"
          ref="mySitesDSGrid"
          :dataSource="mySitesDS"
          :toolbar="toolbarOptions"
          :created="mySitesCreated"
          height="50%"
          :allowSorting="true"
          :allowExcelExport="false"
          :allowPaging="true"
          :pageSettings="pageSettings"
          :allowTextWrap="true"
          :textWrapSettings="wrapSettings"
          :commandClick="cmdEditClick"
          :rowDataBound="rowInvoiceDataBound"
        >
          <e-columns>
            <e-column headerText="Details" textAlign="Left" width="95" :commands="commands" />
            <e-column headerText="Approved" textAlign="Center" width="110" :commands="checkIcon" />
            <e-column field="site_Id" headerText="Site #" textAlign="Center" width="100" />
            <e-column field="owner_Ref_Num" headerText="Customer Ref#" textAlign="center" width="110" />
            <e-column
              field="municipality"
              headerText="Municipality"
              textAlign="Right"
              width="180"
            />
            <e-column field="site_Name" headerText="Site Name" width="300"> </e-column>
            <e-column field="site_Address" headerText="Site Address" width="350" />
            <e-column
              v-if="showAllSites"
              field="registration_Status"
              headerText="Operating Permit Status"
              width="200"
            />
            <e-column field="facility_Status" headerText="Facility Status" width="135" />
            <e-column field="hold_Certificates" headerText="Certificate OnHOLD (Due to Non-Compliance)" width="240" />
            <e-column field="owner_Id" headerText="Owner #" textAlign="center" width="110" />
            
            <e-column field="owner_Name" headerText="Owner Name" textAlign="center" width="250" />
          </e-columns>
        </ejs-grid>
      </div>

      <div v-if="!showAllSites">
        <div style="margin-top: 5px" class="e-card" v-if="showFooter && editPermission">
<<<<<<< HEAD
          <div class="e-card-title">Comments <span class="sub-text">- Complete ONLY if submitting to ASCA Tanks for review and updates are required to your site(s)</span></div>
=======
          <div class="e-card-title">Comments
          <span class="sub-text">- Complete ONLY if submitting to ASCA
            Tanks for review and updates are required to your site(s)
          </span></div>
>>>>>>> r4
          <div style="padding:10px;height: 95px;">
            <ejs-textbox
              float-label-type="Always"
              ref="ownerComments"
              placeholder="Please add your review comments here:"
              :value="ownerComments"
              :maxlength="250"
              @input="onInputChange"
              :multiline="true"
              row="8"
            />
          </div>
        </div>
        <div style="margin-top: 5px" class="e-card" v-if="showFooter && editPermission">
          <div class="e-card-title">Uploaded Documents</div>
          <div class="e-card-separator"></div>
          <div class="e-card-content">
            <div style="display: flex; justify-content: end"></div>
            <ejs-grid
              ref="documentsGrid"
              id="documentsGridId"
              :created="documentsCreated"
              :dataSource="documentsDS"
              :toolbar="toolbarOptions"
              height="50%"
              :allowSorting="true"
              :allowExcelExport="false"
              :allowPaging="true"
              :pageSettings="pageSettings"
              :allowTextWrap="true"
              :commandClick="deleteButtonClick"
            >
              <e-columns>
                <e-column field="documentName" width="400" headerText="Document Name" />
                <e-column
                  headerText="Date Uploaded"
                  type="date"
                  format="dd/MM/yyyy"
                  field="createDate"
                />
                <e-column headerText="Uploaded By" field="createUser" />
                <e-column headerText="Delete Document" :commands="deleteButton" />
              </e-columns>
            </ejs-grid>

            <div
              style="margin-top: 5px; padding: 10px; display: grid; grid-template-columns: 1fr 1fr"
              class="e-card"
            >
              <div>
                <div style="display: flex; justify-content: space-between">
                  <ejs-textbox
                    float-label-type="Always"
                    ref="documentNameTextbox"
                    placeholder="Enter File Name..."
                    @input="onEnteringDocumentName"
                    :maxlength="250"
                    width="70%"
                  />
                  <input
                    type="file"
                    @change="onFileSelection"
                    ref="documentFileUploader"
                    id="document"
                    style="display: none"
                  />
                  <button class="uploadButton e-control e-btn e-lib e-primary">
                    <label for="document"> Select File </label>
                  </button>
                  <button
                    ref="uploadButton"
                    :disabled="disableUploadButton"
                    @click="uploadFile"
                    class="uploadButton e-control e-btn e-lib e-success"
                  >
                    Upload File
                  </button>
                </div>
                <div style="color: grey; font-size: 12px">
                  <b>Note:</b> Do not use special characters: \\/:*?"&lt;>|
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 5px" class="e-card">
          <div class="e-card-title">History</div>
          <ejs-grid
            ref="siteReviewSubmittedHistoriesGrid"
            id="siteReviewSubmittedHistoriesGridId"
            :created="reviewSubmittedHistoryCreated"
            :dataSource="siteReviewSubmittedHistories"
            :toolbar="toolbarOptions"
            :allowSorting="true"
            :allowExcelExport="false"
            :allowPaging="true"
            :pageSettings="pageSettings"
            :allowTextWrap="true"
            :textWrapSettings="wrapSettings"
            :queryCellInfo="customiseCell"
            :commandClick="openPDF"
            >
              <e-columns>
                <e-column
                  field="submitDate"
                  headerText="Submit Date"
                  textAlign="Center"
                  type="date"
                  format="MMM dd,yyyy"
                />
                <e-column field="eventTitle" headerText="Event Title" textAlign="Center" />
                <e-column field="reviewYear" headerText="Year" textAlign="Center" />
                <e-column
                  headerText="Open Document"
                  textAlign="Center"
                  width="200"
                  :commands="pdfButton"
                />
              </e-columns>
            </ejs-grid>
        </div>
        <div style="margin-left: 50%; margin-top: 10px" v-if="showFooter && editPermission">
          <button
            @click="approveButtonClick"
            v-if="!showReview"
            class="e-control e-btn e-lib e-success"
          >
            Approve
          </button>
          <button v-else class="e-control e-btn e-lib e-info" @click="goToReview()">Review</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  GridPlugin,
  Toolbar,
  Filter,
  CommandColumn,
  Sort,
  Search,
  Page,
} from "@syncfusion/ej2-vue-grids";
import appConfig from "@/app.config";
import { mapGetters } from "vuex";
import { tokenStorage } from "@/shared/storage-service";
import { AutoCompletePlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DialogUtility } from "@syncfusion/ej2-popups";
import {
  approveReviewData,
  deleteSiteReviewFile,
  uploadSiteReviewFile,
} from "../services/site-eservices-api";

import { getHistoryPDFByDocumentId } from "../../applications/services/applications-api";

Vue.use(GridPlugin);
Vue.use(AutoCompletePlugin);

let DialogObj;

export default {
  name: "SiteList",
  props: {
    documentsDS: {
      type: Array,
      default() {
        return null;
      },
    },
    showReview: {
      type: Boolean,
      default: false,
    },
    isSiteReviewReadyData: {
      type: Object,
      default() {
        return {};
      },
    },
    ownerInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    comments: {
      type: Array,
      default() {
        return null;
      },
    },
    showAllSites: {
      type: Boolean,
      default: false,
    },
    mySitesDS: Array,
  },

  data() {
    return {
      toolbarOptions: ["Search"],
      pageSettings: { pageSize: 10 },
      loading: false,
      wrapSettings: { wrapMode: "Both" },
      showFooter: false,
      previousValue: null,
      dataToSubmit: {
        ownerId: null,
        ownerContactId: null,
        siteId: null,
        applicationRequestId: null,
        document: {
          documentType: null,
          documentContent: null,
          documentName: null,
        },
      },
      showReopenButton: true,
      documentIdToDelete: null,
      commands: [
        {
          type: "Edit",
          buttonOption: { cssClass: "e-flat", iconCss: "e-open-link e-icons" },
        },
      ],
      pdfButton: [
        {
          type: "Open PDF",
          buttonOption: {
            cssClass: "e-flat pdfBtn",
            iconCss: "e-export-pdf e-icons",
          },
        },
      ],
      deleteButton: [
        {
          type: "Delete Document",
          buttonOption: {
            cssClass: "e-flat deletebtn",
            iconCss: "e-delete e-icons",
          },
        },
      ],
      checkIcon: [
        {
          type: "Reviewed",
          buttonOption: {
            cssClass: "e-flat check",
            iconCss: "e-check e-icons",
          },
        },
      ],
    };
  },

  watch: {
    isSiteReviewReadyData(isSiteReviewReadyData) {
      this.showFooter = isSiteReviewReadyData !== null;
    },
  },
  async created() {
    // --
  },
  computed: {
    ...mapGetters({
      loggedUser: "loggedUser",
    }),

    reviewYear() {
      return this.isSiteReviewReadyData?.reviewYear;
    },
    requestId() {
      return this.isSiteReviewReadyData?.applicationRequestId;
    },
    tmsRegistrationId() {
      return this.isSiteReviewReadyData?.tmsRegistrationId;
    },
    ownerComments() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.$parent.changedComments = this.comments?.find((x) => x.siteId == null)?.comments;
      return this.$parent.changedComments? this.$parent.changedComments: "";
    },

    editPermission() {
      return this.isSiteReviewReadyData?.editPermission;
    },

    siteReviewSubmittedHistories() {
      return this.isSiteReviewReadyData?.siteReviewSubmittedHistories;
    },
    withSubmitedSiteReview() {
      return this.isSiteReviewReadyData?.withSubmitedSiteReview;
    },

    disableUploadButton() {
      const { document } = this.dataToSubmit;
      return !(document.documentName?.length > 0 && document.documentContent?.length > 0);
    },
  },
  methods: {
    customiseCell(e) {
      if (e.column.commands && e.data.documentId == null) {
        e.cell.querySelector(".pdfBtn").classList.add("hidebtn");
      }
    },
    mySitesCreated() {
      // Added clear button and its functionalities to Searchbar

      if (this.$refs.mySitesDSGrid) {
        const mySitesDSGridSearchEle = document.getElementById(
          `${this.$refs.mySitesDSGrid.$el.id}_searchbar`,
        );
        if (mySitesDSGridSearchEle) {
          mySitesDSGridSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.mySitesDSGrid.$el.id);
          });
        }
      }
    },
    documentsCreated() {
      // Added clear button and its functionalities to Searchbar

      if (this.$refs.documentsGrid) {
        const documentsGridSearchEle = document.getElementById(
          `${this.$refs.documentsGrid.$el.id}_searchbar`,
        );

        if (documentsGridSearchEle) {
          documentsGridSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.documentsGrid.$el.id);
          });
        }
      }
    },
    reviewSubmittedHistoryCreated() {
      // Added clear button and its functionalities to Searchbar

      if (this.$refs.siteReviewSubmittedHistoriesGrid) {
        const el = document.getElementById(`${this.$refs.siteReviewSubmittedHistoriesGrid.$el.id}_searchbar`);
        el.addEventListener('keyup', (e) => {
          this.clearSearchEventListener(e, this.$refs.siteReviewSubmittedHistoriesGrid.$el.id);
        });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove("e-search-icon");
      clearBtnEle.classList.add("e-clear-icon");

      clearBtnEle.addEventListener("click", () => {
        e.target.value = "";
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === "") {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async cmdEditClick(args) {
      if (args.commandColumn.type === "Edit") this.$parent.parentSiteClicked(args.rowData.site_Id);
    },

    goToReview() {
      document.getElementById("collapsible_tab").ej2_instances[0].select(3);
    },
    onFileSelection(e) {
      const selectedFile = e.target?.files[0];
      if (selectedFile) {
        const { dataToSubmit } = this;
        dataToSubmit.ownerId = this.mySitesDS[0].owner_Id;
        dataToSubmit.ownerContactId = this.mySitesDS[0].ownerContactID;
        dataToSubmit.applicationRequestId = this.requestId;
        const { document } = dataToSubmit;
        const fileName = selectedFile.name;
        const fileInfo = fileName.split(".");
        // eslint-disable-next-line no-multi-assign
        document.documentType = document.fileType = fileInfo[fileInfo.length - 1];
        document.documentName = fileName.slice(0, fileName.length - (document.fileType.length + 1));
        this.$refs.documentNameTextbox.$el.value = document.documentName;

        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = (es) => {
          const contents = es.target.result;
          if (contents) {
            document.documentContent = contents.substring(contents.indexOf(",") + 1);
          }
        };
      }
    },
    async openPDF(e) {
      const accessToken = tokenStorage.getAccessToken();
      const userId = this.loggedUser.id;
      // const requestId = this.isSiteReviewReadyData?.applicationRequestId;
      await getHistoryPDFByDocumentId(userId, accessToken, e.rowData.documentId).then((res) => {
        window.location.href = `${res.config.baseURL}${res.config.url}`;
      });
    },

    hideDeleteDialog() {
      DialogObj.hide();
    },

    async approve() {
      this.hideDeleteDialog();
      try {
        const { ownerId } = this.ownerInfo;
        const { ownerContactId } = this.ownerInfo;
        let { requestId } = this;
        // eslint-disable-next-line max-len
        await approveReviewData(this.loggedUser.email, ownerId, ownerContactId, requestId).then((res) => {
          this.$parent.isSiteReviewReadyData = res.data;
          requestId = res.data.applicationRequestId;
          this.notify("Success !", "Review approved Successfully");
          if (requestId) {
            this.$router.push({
              name: "PayByRequest",
              params: {
                requestId,
              },
            });
          } else {
            this.$router.push("/reports/transactions");
          }
        });
      } catch (err) {
        this.notify("Error !", "Error occurred while approving review");
      }
    },

    deleteButtonClick(args) {
      this.documentIdToDelete = args.rowData.documentId;
      this.showpopup(
        "deleteDocument",
        "Are you sure you want to delete document?",
        "Delete Document",
      );
    },
    approveButtonClick() {
      this.showpopup(
        "approve",
        "Are you sure you want to approve site review?",
        "Approve Site Review",
      );
    },

    showpopup(functionName, content, title) {
      DialogObj = DialogUtility.confirm({
        title,
        content,
        okButton: { text: "OK", click: this[functionName] },
        cancelButton: { text: "Cancel", click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" },
      });
    },

    async deleteDocument() {
      this.hideDeleteDialog();
      await deleteSiteReviewFile(this.documentIdToDelete)
        .then((res) => {
          const index = this.$parent.documentsDS.findIndex((x) => x.documentId === res.data);
          const parent = this.$parent;
          parent.documentsDS.splice(index, 1);
          parent.showReview = parent.documentsDS?.length > 0 || parent.commentChanges?.length > 0;
          parent.controlNavigationToReview(parent.showReview);
          this.$refs.documentsGrid.refresh();
          this.notify("Success !", "Document deleted Successfully");
        })
        .catch((err) => {
          this.notify("Error !", err.response.data.message);
        });
    },

    onInputChange(e) {
      this.$parent.checkIfCommentsChange(e.value, null);
    },

    onEnteringDocumentName(args) {
      // eslint-disable-next-line no-useless-escape
      const format = /[\/:*?"<>|]/;
      if (format.test(args.event.data)) {
        // eslint-disable-next-line no-param-reassign
        args.container.querySelector("input").value = this.previousValue;
      } else {
        // eslint-disable-next-line no-param-reassign, no-multi-assign
        args.container.querySelector("input").value = this.previousValue = args.value;
      }
      this.dataToSubmit.document.documentName = args.container.querySelector("input").value;
    },
    async uploadFile() {
      const { document } = this.dataToSubmit;
      const fileName = document.documentName;
      const actualFileType = document.fileType;
      let userDefinedType = fileName.split(".");
      userDefinedType = userDefinedType[userDefinedType.length - 1];
      if (userDefinedType.toLowerCase() !== actualFileType.toLowerCase()) {
        document.documentName = `${fileName}.${actualFileType}`;
      }

      await uploadSiteReviewFile(this.dataToSubmit)
        .then((res) => {
          const parent = this.$parent;
          parent.documentsDS.push(res.data.document);
          this.$refs.documentNameTextbox.$el.value = null;
          this.$refs.documentsGrid.refresh();
          this.$refs.documentFileUploader.value = "";
          document.documentName = null;
          parent.showReview = parent.documentsDS.length > 0 || parent.commentChanges.length > 0;
          parent.controlNavigationToReview(parent.showReview);
          this.notify("Success !", "Document uploaded Successfully");
        })
        .catch((err) => {
          this.notify("Error !", err.response.data.message);
        });
    },

    notify(type, message) {
      this.$parent.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === "Error !" ? "e-toast-danger" : "e-toast-success",
        timeOut: 5000,
      });
      if (this.$parent.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$parent.$refs.notifierRef.show();
      }
    },
    onExportToExcel() {
      const accessToken = tokenStorage.getAccessToken();
      const userid = this.$store.getters.loggedUser ? this.$store.getters.loggedUser.id : "";
      const { ownerId } = this.ownerInfo;
      const { ownerContactId } = this.ownerInfo;
      const { ownerEmail } = this.ownerInfo;
      const baseTMSUrl = appConfig.tmsApiRootUrl;
      let newURL = "";
      if (this.showAllSites) {
        newURL = `${baseTMSUrl}/eServicesSite/excel?userid=${userid}&securitytoken=${accessToken}&emailAddress=${ownerEmail}&ownerId=${ownerId}&ownerContactId=${ownerContactId}`;
      } else {
        newURL = `${baseTMSUrl}/eServicesSite/excel?userid=${userid}&securitytoken=${accessToken}&emailAddress=${ownerEmail}&ownerId=${ownerId}&ownerContactId=${ownerContactId}&showIsReadyForCertifyOnly=true`;
      }
      window.location.href = newURL;
    },
    rowInvoiceDataBound(args) {
      if (!args.data.isInvoiced) {
        // args.row.style
        //   .fontWeight = '500';
        // eslint-disable-next-line no-param-reassign
        args.row
          .querySelectorAll('.e-unboundcelldiv')[1]
          .querySelectorAll('button')[0].style.display = 'none';
      }
    },
  },

  provide: {
    grid: [Toolbar, Filter, CommandColumn, Sort, Search, Page],
  },
};
</script>
<style scoped>
.uploadButton {
  height: 30px;
  margin-top: 2.5%;
}
.hidebtn {
  display: none;
}
</style>
